import { Suspense, lazy, ComponentType } from "react";
import { DigitalGeniusChatContextProvider } from "./contexts/DigitalGeniusChatContext";
//import MembersPortal from "./MembersPortal";
//import Checkout from "./Checkout";
import "./App.scss";

// this retry was written for components exported via: "export default ComponentName;"
export function retryIfImportFailed(fn: Function, retriesLeft: number = 5, interval: number = 200) {
	return new Promise<{ default: ComponentType<any>; }>((resolve, reject) => {
		fn()
		.then(resolve)
		.catch((error: any) => {
			setTimeout(() => {
				if (retriesLeft === 0) {
					// reject("maximum retries exceeded");
					reject(error);
					return;
				}
				// Passing on "reject" is the important part
				retryIfImportFailed(fn, retriesLeft - 1, interval).then(resolve, reject);
			}, interval);
		});
	});
}

//const MembersPortal = lazy(async () => await import("./MembersPortal"));
const MembersPortal = lazy(() => retryIfImportFailed(async () => await import("./MembersPortal")));
//const Checkout = lazy(async () => await import("./Checkout"));
const Checkout = lazy(() => retryIfImportFailed(async () => await import("./Checkout")));

type AllowedSubdomainType = "members" | "checkout" | "localhost:3000";
type AllowedOverrideType = "members" | "checkout";

function getWindowSubdomain(localHost_SubdomainOverride?: AllowedOverrideType) {
	const host = window.location.host;
	const parts = host.split(".");
	const subdomain = parts[0];

	// when built just ignore any overrides and use the appropriate subdomain
	if (import.meta.env.REACT_APP_ENV === "checkout-dist" || import.meta.env.REACT_APP_ENV ===  "checkout-dist-eu") {
		return "checkout" as AllowedSubdomainType;
	}
	else if (import.meta.env.REACT_APP_ENV === "dist" || import.meta.env.REACT_APP_ENV === "dist-eu") {
		return "members" as AllowedSubdomainType;
	}

	if (localHost_SubdomainOverride === "checkout") {
		return "checkout" as AllowedSubdomainType;
	}
	if (localHost_SubdomainOverride === "members") {
		return "members" as AllowedSubdomainType;
	}
	else {
		// if no override is set and we are at local host, default to members portal
		if (subdomain === "localhost:3000") {
			return "members" as AllowedSubdomainType;
		}

		return subdomain as AllowedSubdomainType;
	}
}


function App() {
	return (
		<div className="app-css">
			{/** 
			NOTE!: use ONLY getWindowSubdomain() when building for test/deploy (getWindowSubdomain("checkout") is used only when testing and building locally)
			Even though we set this via import.meta.env.REACT_APP_ENV during build, we should never commit getWindowSubdomain() with an override
			*/}
			{(getWindowSubdomain("members") === "members") ? 
				<DigitalGeniusChatContextProvider>
					<Suspense fallback={<div className="app-loading-text">Loading ...</div>}>
						<MembersPortal /> 
					</Suspense>
				</DigitalGeniusChatContextProvider> : 
				<Suspense fallback={<div className="app-loading-text">Loading ...</div>}>
					<Checkout />
				</Suspense>
			}
		</div>
	);
}

export default App;
